let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;

  //Scrolling Banner test
  const c_heroimage = window.igData?.user.getTestGroup(
    "77dc5d41-6ae7-4be8-9ec1-cb296b857811"
  );
  if (c_heroimage?.name === "Var A") {
    document.body.classList.add("c-heroimage-varA");
  }

  //Scrolling Banner test
  const c_scrollingBanner = window.igData?.user.getTestGroup(
    "5464b04f-3945-456e-9434-95d42fdf79bd"
  );
  if (c_scrollingBanner?.name === "Var A") {
    document.body.classList.add("c-scrolling-banner-varA");
  }

  // Testimonial in Drawer
  const c_Testimonial_test = window.igData?.user.getTestGroup(
    "922dc703-f6d8-4c39-8b7b-0a72f40363b5"
  );

  if (c_Testimonial_test?.name === "Var A") {
    document.querySelectorAll(".C-testimonial").forEach((el) => {
      el.style.display = "flex";
    });
  }


}

// Check if DOM is already loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    domLoaded = true;
    handleExperiments();
  });
} else {
  domLoaded = true;
  handleExperiments();
}

// Check for ig:ready event
if (window.igData) {
  igReady = true;
  handleExperiments();
} else {
  window.addEventListener("ig:ready", () => {
    igReady = true;
    handleExperiments();
  });
}